// @ts-nocheck

export type TenantGetWithRoomProperty = typeof TenantGetWithRoomProperty[keyof typeof TenantGetWithRoomProperty];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantGetWithRoomProperty = {
  true: 'true',
  false: 'false',
} as const;
